import React, {Component} from 'react';
import PeriodDropDown from './PeriodDropDown'
import PeriodPicker from '../PeriodPicker'
import PeriodRender from './PeriodRender'

import {convertLocalToZoneTime} from '../../timeFunctions/TimeZone'
import { mediumFormat } from '../../timeFunctions/timeFns';

import '../../Overview/overview.css'
import './filterpanel.css'
import './period-dropdown.css';

export default class DatePanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startTime: this.props?.startTime ?? new Date(Date.now() - 24*3600 * 1000),
      endTime: this.props?.endTime ?? new Date(),
      dropDown: this.props.dropDown ?? 0,
      desc: "Last day",
      modalShow: false
    };
    this.getPeriod = this.getPeriod.bind(this);
    this.setPeriod = this.setPeriod.bind(this);
    this.interval = this.interval.bind(this);
  }

  setPeriod (start, end, item, description) {
    const newValues = {startTime: start, endTime: end, dropDown: item, 
          desc: description ?? this.state.desc};
    this.setState(newValues);
    if (this.props.propagateState)
      this.props.propagateState ('date', newValues);
  }

  getPeriod () {
    return [this.state.startTime, this.state.endTime]
  }

  getPeriodName() {
    return this.state.desc
  }
  pickDateVisible(state) {
    this.setState({ modalShow: state});
  }

  interval (fn_start, fn_end = null, item, description) {
    if (item === 4) {
      this.pickDateVisible(true)
    }
    let period = this.getPeriod();
    if (typeof fn_start === 'function') 
      period[0] = fn_start (this.state.endTime);
    else if (fn_start?.getMonth)
      period[0] = fn_start

    if (typeof fn_end === 'function') 
      period[1] = fn_end(this.state.endTime)
    else if (fn_end?.getMonth)
      period[1] = fn_end
    this.setPeriod(period[0], period[1], item, description)
  }

  render() {
    let startTime = this.state.startTime;
    let endTime = this.state.endTime;
    if (this.props?.tz) {
      startTime = convertLocalToZoneTime (startTime, this.props.tz);
      endTime = convertLocalToZoneTime (endTime, this.props.tz);
    }
    return (
      <div className="panel-dropdown">
        <div className="pcos">
        <PeriodDropDown onUpdate={this.interval} {...this.props} />
        <PeriodRender from={mediumFormat (startTime)} to={mediumFormat(endTime)} />
        </div>
        <PeriodPicker show={this.state.modalShow} hide={()=>this.pickDateVisible(false)} 
          period={this.getPeriod()} onChange={this.setPeriod}/>
      </div>
    )  
  }
}
